import React from "react";
import { DetailedRequisitionSerializer } from "../../recoil/types";
import { DownloadIcon } from "../../assets/iconComponents/DownloadIcon";
import {
  ReportDownloadLink,
  ResultInfoContainer,
  ResultInfoIcon,
  ResultInfoIconWrapper,
  ResultInfoTitle,
} from "./UserReport.styles";
import { useReportDownload } from "../../utils/hooks/useReportDownload";
import { getIcon } from "../Grid/ReportStatusIcon";
import { StatusIconSlot } from "../shared/StatusIconSlot.styles";
import { RefreshRequisitionRows } from "../Grid/Services/GridService";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";
import { useRequisitionSetter } from "../../recoil/useRequisitionSetter";

const CfcReportDownload: React.FC<{
  cfcReport: DetailedRequisitionSerializer["cfc_report"];
}> = ({ cfcReport }) => {
  const { auth, setLoggedOut } = useAuthenticationHook();
  const { setRequisitions, searchText } = useRequisitionSetter();
  const { downloadReport, isDownloading } = useReportDownload();
  const { report_pk: reportId, status, is_lims: isLims } = cfcReport;
  const isReportAvailable =
    !!reportId && status !== "Not Ordered" && status !== "Processing";
  const { icon, styles } = getIcon(status);
  const handleDownload = async () => {
    if (!reportId) return;

    const downloadSucceeded = await downloadReport(
      reportId,
      "cfc",
      "report_screen",
    );
    if (!downloadSucceeded) return;

    await RefreshRequisitionRows(
      auth!.token,
      setRequisitions,
      setLoggedOut,
      searchText,
    );
  };

  return (
    <ResultInfoContainer>
      <ResultInfoTitle>Unity Confirm™ Results</ResultInfoTitle>
      <ResultInfoIconWrapper downloadIcon={isReportAvailable}>
        {!isReportAvailable && (
          <ResultInfoIcon>
            {icon && <StatusIconSlot>{icon}</StatusIconSlot>}
            <span style={styles}>{status}</span>
          </ResultInfoIcon>
        )}
        {isReportAvailable &&
          (isLims ? (
            <DownloadIcon
              title="This report is unavailable to download - please call customer service."
              color="#FFB6B3"
            />
          ) : (
            <ReportDownloadLink
              type="button"
              disabled={isDownloading}
              onClick={handleDownload}
            >
              Download report
              <DownloadIcon />
            </ReportDownloadLink>
          ))}
      </ResultInfoIconWrapper>
    </ResultInfoContainer>
  );
};

export default CfcReportDownload;
